import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { getCourseList } from "../../../../service/endpoints";

export const CourseHandler = createAsyncThunk('CourseHandler', async (data) => {
  try {
    const response = await getCourseList(data);
    console.log(response, 'course');
    return response.data;


  } catch (error) {
    if (error.response !== undefined) {
      console.log('fail', error);
      throw error.response;
    } else
    {
      console.log(error);
      throw error.response;
    }
  }
});




const CourseListSlice = createSlice({
  name: 'getCourses',
  initialState: {
    isLoading: false,
    data: null,
    isError: false
  },
  extraReducers: (builder) => {
    builder.addCase(CourseHandler.fulfilled, (state, action) => {
      state.isLoading = false;
      state.data = action.payload;
    });
    builder.addCase(CourseHandler.pending, (state, action) => {
      state.isLoading = true;
    });
    builder.addCase(CourseHandler.rejected, (state, action) => {
      console.log(action.state);
      state.isError = true;
      console.log(action.payload);

    });

  }

});



export default CourseListSlice.reducer;